import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { UserRole, userRolesSchema } from './user-role';

export type User = {
	id: number;
	name: string;
	account: EntityWithName;
	role: UserRole;
	note?: string | null;
	hasMultiLogin: boolean;
	isLocked: boolean;
};

export const userSchema: ZodType<User> = z.object({
	id: z.number(),
	name: z.string(),
	account: entityWithNameSchema,
	role: userRolesSchema,
	note: z.string().nullable().optional(),
	hasMultiLogin: z.boolean(),
	isLocked: z.boolean(),
});
